/// <amd-module name="Build/Admin/Pool/Components/ElasticNodeList" />
import * as React from "react";

import { ObservableValue } from "VSS/Core/Observable";

import { Ago } from "VSSUI/Ago";
import { Button } from "VSSUI/Button";
import { ConditionalChildren } from "VSSUI/ConditionalChildren";
import { Table, ITableColumn, SimpleTableCell, TableColumnStyle } from "VSSUI/Table";
import { Tooltip } from "VSSUI/TooltipEx";
import { AgoFormat } from "VSSUI/Utilities/Date";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";

import { ElasticNode, ElasticNodeState } from "DistributedTask/Client/Contracts/TaskAgent";

import * as Resources from "Build/Admin/Pool/Resources";

export interface IElasticNodeListProps {
    elasticNodes: ElasticNode[];
    onDeleteNode(elasticNode: ElasticNode): void;
}

export class ElasticNodeList extends React.PureComponent<IElasticNodeListProps> {

    public render(): JSX.Element {
        return (
            <Table<ElasticNode>
                className="pipelines-agents-list"
                columns={this._getColumns()}
                itemProvider={new ArrayItemProvider<ElasticNode>(this.props.elasticNodes)}
                />
        );
    }

    private _getColumns(): ITableColumn<ElasticNode>[] {
        return  [
            {
                id: "name",
                name: Resources.Name,
                width: new ObservableValue(-80),
                columnStyle: TableColumnStyle.Primary,
                renderCell: this._renderNameCell
            },{
                id: "saved",
                name: Resources.Saved,
                columnStyle: TableColumnStyle.Tertiary,
                width: new ObservableValue(-20),
                renderCell: this._renderSavedTimeCell
            },
            {
                id: "release",
                width: new ObservableValue(100),
                columnStyle: TableColumnStyle.Secondary,
                renderCell: this._renderDeleteCell
            }
        ];
    }

    private _renderNameCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<ElasticNode>, tableItem: ElasticNode): JSX.Element => {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex}>
                <Tooltip overflowOnly={true}>
                    <span className="fontWeightSemiBold fontSizeM text-ellipsis">
                        {tableItem.name}
                    </span>
                </Tooltip>
            </SimpleTableCell>
        );
    }

    private _renderSavedTimeCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<ElasticNode>, tableItem: ElasticNode): JSX.Element => {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex}>
                <span className="text-ellipsis bolt-list-cell-text">
                    <ConditionalChildren renderChildren={tableItem.stateChangedOn !== undefined}>
                        <Ago date={tableItem.stateChangedOn} format={AgoFormat.Extended} />
                    </ConditionalChildren>
                </span>
            </SimpleTableCell>
        );
    }

    private _renderDeleteCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<ElasticNode>, tableItem: ElasticNode): JSX.Element => {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex}>
                <ConditionalChildren renderChildren={tableItem.state === ElasticNodeState.Saved}>
                    <Button text={Resources.Delete} onClick={() => this.props.onDeleteNode(tableItem)} primary={true} />
                </ConditionalChildren>
            </SimpleTableCell>
        );
    }
}
